<template>
    <div class="l-h">
            <div class="w-1200 l-h-d">
                <div class="l-t pointer" @click="gotoHome()" >
                    <p class="cn pointer" >基于区域医联体模式的国产创新诊疗设备服务云平台</p>
                    <p class="en">DOMESTIC INNOVATIVE DIAGNOSIS AND TREATMENT EQUIPMENT SERVICE CLOUD PLATFORM</p>
                </div>
                <!-- <div v-if="type==1" :class="' l-tip '+(tip=='登录'?'tip-bg-color1':'tip-bg-color2')">
                    <p>{{tip}}</p>
                </div> -->
                
                <span v-if="type==1" class="to-home pointer" @click="gotoHome()">返回首页</span>
                
                <div v-if="type==2" class="l-search">
                    <div class="l-s-input">
                        <div class="com-header input">
                            <el-input class="input-box" v-model="input2" placeholder="请输入需要搜索的内容"></el-input>
                        </div>
                        <div class="button pointer" @click="search"><span style="padding-right:10px;">搜</span>索</div>
                    </div>
                    <div class="l-s-tip">
                        <el-breadcrumb separator="|">
                            <el-breadcrumb-item>创新诊疗装备</el-breadcrumb-item>
                            <el-breadcrumb-item>医域医联体</el-breadcrumb-item>
                            <el-breadcrumb-item>示范云平台</el-breadcrumb-item>
                            <!-- <el-breadcrumb-item v-for="(item,index) in hotWords" :key="index">{{item}}</el-breadcrumb-item> -->
                        </el-breadcrumb>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    name:'comHeader',
    props:{
        type:{
            default:1,
        },
        tip:{
            default:'登录'
        },
    },
    data(){
        return{
            input2:'',
            hotWords:[],
        }
    },
    created(){
        this.getHotWord();
    },
    methods:{
        getHotWord(){
            this.get(this.api.hotWords).then(res=>{
                for(var i =0; i<res.data.length;i++){    
                    this.hotWords[i]=res.data[i];
                }
            }).catch();
        },
        search(){
            if(this.$route.path=='/homeSearch'){
                this.$store.commit('setSearch',this.input2);
            }else{
                this.$router.push({path:'/homeSearch',query:{input:this.input2}});
            }
            this.input2='';
        },
        gotoHome(){
            this.routerToUrl('/home');
        }
    }
    
}
</script>

<style lang="scss">
.l-h{
    width:100%;
    height:100px;
    background: white;
    .l-h-d{
        margin: 0 auto;
        height:80px;
        padding-top:20px;
    }
}
p{
    margin: 0;
}
.to-home{
   
    float:right;
    margin-top:5px;
    margin-right:10px;
    padding:10px;
    width:80px;
    color:#2077E0;
    font-size: 20px;
    border: 1px solid #1C66AF;
    border-radius: 5px;
}
.l-t{
    padding-left: 90px;
    // width:480px;
    height: 60px;
    background: url(../assets/image/login/login-icon.png) no-repeat 0 center;
    float: left;
}
.l-tip{
    width:160px;
    margin-top:5px;
    margin-left:20px;
    height:45px;
    
    border-radius:3px;
    line-height:45px;
    float: left;
    p{
        height:100%;
        color:white;
        font-size: 24px;
        text-align: center;
    }
    
}
.tip-bg-color1{
        background:linear-gradient(90deg,rgba(16,80,143,1),rgba(30,106,180,1));
    }
.tip-bg-color2{
    background:linear-gradient(90deg,rgba(255,174,0,1),rgba(255,150,0,1));
}
.l-search{
    width:30%;
    height:80px;
    float: right;
    .l-s-input{
        width:100%;
        height:40px;
        .input{
            box-sizing: border-box;
            width:calc(100% - 80px);
            padding-left:30px;
            background:url('../assets/image/login/search-icon.png')no-repeat 10px center;
            height:100%;
            border: 2px solid #318CE7;
            float: left;
            img{
                position:relative;
                top:3px;
                left:5px;
            }
        }
        .button{
            width:80px;
            height:100%;
            box-sizing: border-box;
            background: #318CE7;
            color:white;
            float: left;
            line-height:40px;
            text-align: center;
        }
    }
    .l-s-tip{
        overflow: hidden;
        height:20px;
        padding-top:10px;
        padding-left:5px;
    }
}
.cn{
    width:100%;
    height:40px;
    font-size: 30px;
    font-size: 28px;
}
.en{
    width:100%;
    height:20px;
    font-size: 14px;
}
.com-header{
    .input-box{
        .el-input__inner {
            border: none!important;
            height:36px!important;
            line-height:36px!important;
            padding-left:5px!important;
        }
    }
}
</style>